import { useDispatch } from "react-redux";
import { errorActions } from "../actions";

export const useCopyToClipboard = (onCopySuccess?: () => void) => {
    const dispatch = useDispatch();

    const copyToClipboard = async (textToCopy: string) => {
        try {
            await navigator.clipboard.writeText(textToCopy);
            onCopySuccess?.();
        } catch (e) {
            dispatch(errorActions.unexpectedError(e));
        }
    };

    return { copyToClipboard };
};

